import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { DURATION_MS } from 'app/constants/CronTimes';
import { config } from 'config/env';
import { fetchJusGptV2Access } from './api';

export const JUSGPT_V2_ACCESS_QUERY_KEY = ['jusgpt', 'v2-access'] as const;

/**
 * Diz se este advogado abre a interface 2.0 do JusGPT.
 *
 * Sem `meta.persist`: acesso não pode vir do cache de 24h do localStorage. O
 * backend revoga e o front precisa acompanhar na sessão seguinte.
 *
 * `retry: false` porque o fallback já é o comportamento certo — insistir só
 * atrasa a decisão do menu. `enabled` fica desligado enquanto a resposta não
 * chega: quem clica nesse intervalo vai pro JusGPT, que funciona.
 */
export function useJusGptV2Access(): { enabled: boolean } {
  const authToken = useSelector(
    (state: { auth?: { authToken?: string | null } }) =>
      state.auth?.authToken ?? '',
  );
  const temConfig = Boolean(config.jusGpt?.apiUrl);

  const { data } = useQuery({
    queryKey: JUSGPT_V2_ACCESS_QUERY_KEY,
    queryFn: () => fetchJusGptV2Access(authToken),
    enabled: Boolean(authToken) && temConfig,
    staleTime: DURATION_MS.FIVE_MINUTES,
    retry: false,
  });

  return { enabled: data === true };
}
